// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/logo-white-text.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout_header__Djwpo {
  background-color: var(--branded-dark-gray) !important;
}

.Layout_footer__yWHgf {
  margin: 30px 0 15px 0;
  font-size: 0.8rem;
  text-align: center;
}

.Layout_top__-sosh {
  padding: 5px 0;
}

.Layout_wrapper__fnEfK {
  display: flex;
  justify-content: space-between;
}

.Layout_secondary__k9PLu {
  background-color: var(--branded-purple);
}

.Layout_user_icon__txDm5:hover {
  background-color: transparent !important;
  border: none !important;
}

.Layout_menu_divider__xUj4N {
  height: 2px;
  background-color: var(--branded-light-purple);
  width: 83%;
  margin-left: 7%;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
}

.Layout_menu_button__K3Z7x {
  background-color: transparent !important;
  border: none !important;
  width: auto;
  display: flex;
  gap: 5px;
  padding-top: 0px;
}

.Layout_menu_button__K3Z7x:hover {
  background-color: transparent !important;
  border: none !important;
}

.Layout_menu_preferences__X87mJ {
  padding: 0.5rem 0;
}

.Layout_menu_preferences_header__\\+znDX {
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.Layout_menu_preferences_header__\\+znDX i {
  margin-right: 0.5rem;
  font-size: 1rem;
}

.Layout_menu_preferences_header__\\+znDX span {
  font-weight: bold;
  font-size: 0.9rem;
}

.Layout_menu_preferences_links__5CGBa button {
  all: unset;
  cursor: pointer;
  width: 60%;
  padding: 0.3rem 2.5rem;
  display: block;
  font-size: 0.9rem;
  color: var(--branded-font-color);
}

.Layout_menu_preferences_links__5CGBa button:hover {
  background-color: #e9ecef;
}

.Layout_menu_preferences_links__5CGBa a {
  padding: 0.3rem 2.5rem;
  display: block;
  font-size: 0.9rem;
  text-decoration: none;
  color: var(--branded-font-color);
}

.Layout_menu_preferences_links__5CGBa a:hover {
  background-color: #e9ecef;
}

.Layout_menu_icon_button__8s60j {
  display: none;

  background-color: transparent !important;
  border: none !important;
  padding: 0;

  span {
    color: white;
  }
}

/* Mobile */
@media (max-width: 767px) {
  .Layout_menu_button__K3Z7x {
    display: none;
  }

  .Layout_menu_icon_button__8s60j {
    display: block;
  }

  .Layout_logo_container__Z09Kf {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    width: 24px;
    height: 36px;
  }
}

@media (min-width: 768px) {
  .Layout_logo_container__Z09Kf {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: center;
    width: 96px;
    height: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Layout.module.css"],"names":[],"mappings":"AAAA;EACE,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,6CAA6C;EAC7C,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;;EAEb,wCAAwC;EACxC,uBAAuB;EACvB,UAAU;;EAEV;IACE,YAAY;EACd;AACF;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yDAAkD;IAClD,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,yDAA6D;IAC7D,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".header {\n  background-color: var(--branded-dark-gray) !important;\n}\n\n.footer {\n  margin: 30px 0 15px 0;\n  font-size: 0.8rem;\n  text-align: center;\n}\n\n.top {\n  padding: 5px 0;\n}\n\n.wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.secondary {\n  background-color: var(--branded-purple);\n}\n\n.user_icon:hover {\n  background-color: transparent !important;\n  border: none !important;\n}\n\n.menu_divider {\n  height: 2px;\n  background-color: var(--branded-light-purple);\n  width: 83%;\n  margin-left: 7%;\n  margin-top: 0.6rem;\n  margin-bottom: 0.6rem;\n}\n\n.menu_button {\n  background-color: transparent !important;\n  border: none !important;\n  width: auto;\n  display: flex;\n  gap: 5px;\n  padding-top: 0px;\n}\n\n.menu_button:hover {\n  background-color: transparent !important;\n  border: none !important;\n}\n\n.menu_preferences {\n  padding: 0.5rem 0;\n}\n\n.menu_preferences_header {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.menu_preferences_header i {\n  margin-right: 0.5rem;\n  font-size: 1rem;\n}\n\n.menu_preferences_header span {\n  font-weight: bold;\n  font-size: 0.9rem;\n}\n\n.menu_preferences_links button {\n  all: unset;\n  cursor: pointer;\n  width: 60%;\n  padding: 0.3rem 2.5rem;\n  display: block;\n  font-size: 0.9rem;\n  color: var(--branded-font-color);\n}\n\n.menu_preferences_links button:hover {\n  background-color: #e9ecef;\n}\n\n.menu_preferences_links a {\n  padding: 0.3rem 2.5rem;\n  display: block;\n  font-size: 0.9rem;\n  text-decoration: none;\n  color: var(--branded-font-color);\n}\n\n.menu_preferences_links a:hover {\n  background-color: #e9ecef;\n}\n\n.menu_icon_button {\n  display: none;\n\n  background-color: transparent !important;\n  border: none !important;\n  padding: 0;\n\n  span {\n    color: white;\n  }\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .menu_button {\n    display: none;\n  }\n\n  .menu_icon_button {\n    display: block;\n  }\n\n  .logo_container {\n    background-image: url(\"../assets/images/logo.png\");\n    background-size: cover;\n    background-position: center;\n    width: 24px;\n    height: 36px;\n  }\n}\n\n@media (min-width: 768px) {\n  .logo_container {\n    background-image: url(\"../assets/images/logo-white-text.png\");\n    background-size: cover;\n    background-position: center;\n    width: 96px;\n    height: 36px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Layout_header__Djwpo`,
	"footer": `Layout_footer__yWHgf`,
	"top": `Layout_top__-sosh`,
	"wrapper": `Layout_wrapper__fnEfK`,
	"secondary": `Layout_secondary__k9PLu`,
	"user_icon": `Layout_user_icon__txDm5`,
	"menu_divider": `Layout_menu_divider__xUj4N`,
	"menu_button": `Layout_menu_button__K3Z7x`,
	"menu_preferences": `Layout_menu_preferences__X87mJ`,
	"menu_preferences_header": `Layout_menu_preferences_header__+znDX`,
	"menu_preferences_links": `Layout_menu_preferences_links__5CGBa`,
	"menu_icon_button": `Layout_menu_icon_button__8s60j`,
	"logo_container": `Layout_logo_container__Z09Kf`
};
export default ___CSS_LOADER_EXPORT___;
